import { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TableCell } from '@bevy/bevy-design-system';

import { useHasScrollContent } from '~/shared/hooks';

import styles from './styles.module.less';

export default function StickyCell({ children, stickyAlign = 'right' }) {
  // This is not a perfect solution, but it's the best we can do without needing to pass lots of props around
  // Tech-debt: BDS Table to support setting a context value determining if the body has scroll content
  // then StickyCell can use that context value to determine if it should set the stuck class
  const [cellRef, setCellRef] = useState(null);
  const bodyRef = cellRef?.parentNode?.parentNode?.parentNode;
  const isStuck = useHasScrollContent(bodyRef);

  return (
    <div
      ref={setCellRef}
      className={classNames(styles.stickyCell, {
        [styles.left]: stickyAlign === 'left',
        [styles.right]: stickyAlign === 'right',
        [styles.stuck]: isStuck,
      })}
    >
      <TableCell>{children}</TableCell>
    </div>
  );
}

StickyCell.propTypes = {
  children: PropTypes.node,
  stickyAlign: PropTypes.oneOf(['left', 'right']),
  isStuck: PropTypes.bool,
};
